import { useUserDateFormat } from "../../core/useFormatUserDate";
import { format } from 'date-fns';
import styled from 'styled-components';
import { Label, tombac } from 'tombac';
import { PinIcon } from 'tombac-icons';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export function EditUserFormPinnedNotes(_ref) {
  let {
    pinnedNotes
  } = _ref;
  const dateFormat = useUserDateFormat();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: pinnedNotes.length > 0 && /*#__PURE__*/_jsxs(PinnedNotes.Root, {
      className: "EditUserPage__section",
      children: [/*#__PURE__*/_jsx(PinnedNotes.PinIcon, {}), /*#__PURE__*/_jsxs("div", {
        style: {
          maxWidth: '1000px'
        },
        children: [/*#__PURE__*/_jsx(Label, {
          children: "Pinned notes"
        }), pinnedNotes.map((pinnedNote, index) => /*#__PURE__*/_jsxs(PinnedNotes.NoteItem, {
          children: [/*#__PURE__*/_jsxs(PinnedNotes.NoteItemDescription, {
            children: [index + 1, ". ", pinnedNote.content]
          }), /*#__PURE__*/_jsx(PinnedNotes.Separator, {
            children: "|"
          }), /*#__PURE__*/_jsxs(PinnedNotes.NoteItemAuthorAndDate, {
            children: ["Added by ", pinnedNote.writer, ",", ' ', format(Date.parse(pinnedNote.createdAt.toString()), dateFormat)]
          })]
        }, index))]
      })]
    })
  });
}
const PinnedNotes = {
  Root: styled.div.withConfig({
    displayName: "EditUserFormPinnedNotes__Root"
  })(["display:flex;gap:", ";"], tombac.space(2)),
  PinIcon: styled(PinIcon).withConfig({
    displayName: "EditUserFormPinnedNotes__PinIcon"
  })(["fill:black;margin-top:5px;width:20px;height:20px;"]),
  Separator: styled.span.withConfig({
    displayName: "EditUserFormPinnedNotes__Separator"
  })(["margin-left:", ";margin-right:", ";color:", ";"], tombac.space(2), tombac.space(2), tombac.color('neutral', 600)),
  NoteItem: styled.div.withConfig({
    displayName: "EditUserFormPinnedNotes__NoteItem"
  })(["font-family:'Proxima Nova';font-size:12px;font-weight:400;letter-spacing:0px;"]),
  NoteItemDescription: styled.span.withConfig({
    displayName: "EditUserFormPinnedNotes__NoteItemDescription"
  })(["color:", ";"], tombac.color('neutral', 700)),
  NoteItemAuthorAndDate: styled.span.withConfig({
    displayName: "EditUserFormPinnedNotes__NoteItemAuthorAndDate"
  })(["color:", ";"], tombac.color('neutral', 900))
};